import {createSubmitRequestTypes} from "./helpers";

export const REQUEST_CREATE_PARTNER = "PARTNER:REQUEST_CREATE_PARTNER";
export const CREATE_PARTNER = createSubmitRequestTypes("PARTNER:CREATE_PARTNER");
// `role` ("client", "supplier" or "") is the role filter in view: the new one starts with it.
export const requestCreatePartner = (role = "") => ({ type: REQUEST_CREATE_PARTNER, role });
export const cancelCreatePartner = () => ({ type: CREATE_PARTNER.CANCEL });
export const successCreatePartner = () => ({ type: CREATE_PARTNER.SUCCESS });

export const REQUEST_EDIT_PARTNER = "PARTNER:REQUEST_EDIT_PARTNER";
export const EDIT_PARTNER = createSubmitRequestTypes("PARTNER:EDIT_PARTNER");
export const requestEditPartner = (partnerId, role = "") => ({ type: REQUEST_EDIT_PARTNER, partnerId, role });
export const cancelEditPartner = () => ({ type: EDIT_PARTNER.CANCEL });
export const successEditPartner = () => ({ type: EDIT_PARTNER.SUCCESS });

// Adds (no addressId) or edits one of a partner's saved addresses.
export const REQUEST_EDIT_PARTNER_ADDRESS = "PARTNER:REQUEST_EDIT_PARTNER_ADDRESS";
export const EDIT_PARTNER_ADDRESS = createSubmitRequestTypes("PARTNER:EDIT_PARTNER_ADDRESS");
export const requestEditPartnerAddress = (partnerId, addressId = "") => ({ type: REQUEST_EDIT_PARTNER_ADDRESS, partnerId, addressId });
export const cancelEditPartnerAddress = () => ({ type: EDIT_PARTNER_ADDRESS.CANCEL });
export const successEditPartnerAddress = () => ({ type: EDIT_PARTNER_ADDRESS.SUCCESS });
